import { lazy } from 'react';

import FastagListing from '../pages/Fastag/Listing';
import FastagDetail from '../pages/Fastag/Detail';
import FastagPassbook from '../pages/Fastag/Passbook';
import Payment from '../pages/Payment';
import Response from '../components/Payment/Response';

const Workflow = lazy(() => import('../pages/workflow'));
// const Demand = lazy(() => import('../pages/workflow/demand'));
// const Placement = lazy(() => import('../pages/workflow/placement'));
const Scheduled = lazy(() => import('../pages/workflow/scheduled'));
// const Transit = lazy(() => import('../pages/workflow/transit'));
// const History = lazy(() => import('../pages/workflow/history'));
const Collection = lazy(() => import('../pages/workflow/collection'));
const Docket = lazy(() => import('../pages/workflow/docket'));
const PrivacyPolicyOperator = lazy(() => import('../pages/public/privacy-policy/operator'));
const PrivacyPolicyThor = lazy(() => import('../pages/public/privacy-policy/thor'));
const PrivacyPolicyConsigner = lazy(() => import('../pages/public/privacy-policy/consigner'));
const PrivacyPolicyHulk = lazy(() => import('../pages/public/privacy-policy/hulk'));
const PrivacyPolicyPump = lazy(() => import('../pages/public/privacy-policy/pump'));
const TermsOfUse = lazy(() => import('../pages/public/terms-of-use'));
const TermsAndConditionsInsuranceConsigner = lazy(
  () => import('../pages/public/terms-and-conditions/insurance-consigner'),
);
const AgentTerms = lazy(() => import('../pages/public/terms-of-use/agent'));
const CookiePolicy = lazy(() => import('../pages/public/cookie-policy'));
const DetentionPolicy = lazy(() => import('../pages/public/operator-policy/detention'));
const CancellationPolicy = lazy(() => import('../pages/public/operator-policy/cancellation'));
const GtlDelay = lazy(() => import('../pages/public/operator-policy/gtlDelay'));
const TokenRefund = lazy(() => import('../pages/public/operator-policy/tokenRefund'));
const OverHeight = lazy(() => import('../pages/public/operator-policy/overHeight'));
const Tds = lazy(() => import('../pages/public/operator-policy/tds-policy'));
const OverLoad = lazy(() => import('../pages/public/operator-policy/overLoad'));
const ServiceBlacklist = lazy(() => import('../pages/public/operator-policy/serviceBlacklist'));
const TransitDelay = lazy(() => import('../pages/public/operator-policy/transitDelay'));

const LoadingUnloading = lazy(() => import('../pages/public/operator-policy/loading-unloading'));
const DamageShortage = lazy(() => import('../pages/public/operator-policy/damage-shortage'));
const PaymentPage = lazy(() => import('../pages/public/payments'));
const PlanPage = lazy(() => import('../pages/public/plan'));
const FleetLoadConfirmation = lazy(() => import('../pages/public/fleet-load-confirmation'));
const OperatorTdsDeclaration = lazy(() => import('../pages/public/operator-tds-declaration/operator-tds-declaration'));
const OperatorUndertaking = lazy(() => import('../pages/public/operator-undertaking/operator-undertaking'));
const DemandCancellationPolicy = lazy(() => import('../pages/public/demand-cancellation-policy'));
const DemandModificationPolicy = lazy(() => import('../pages/public/demand-modification-policy'));

const Marketplace = lazy(() => import('../pages/web-views/marketplace'));
const Trips = lazy(() => import('../pages/web-views/marketplace/trips'));

const TdsDeclaration = lazy(() => import('../pages/web-views/tdsDecalartion/tdsDecalartion'));

const ActiveLoads = lazy(() => import('../pages/web-views/marketplace/active-loads'));
const WhatsAppForm = lazy(() => import('../pages/web-views/marketplace/whatsapp-form'));
const TripDetails = lazy(() => import('../pages/web-views/marketplace/trips/details'));
const TripDetailsV2 = lazy(() => import('../pages/web-views/marketplace/trips/detailsV2'));
const UpdateConsignment = lazy(() => import('../pages/update-consignment'));
const ConsignerVehicle = lazy(() => import('../pages/consigner/vehicles'));
const ConsignerTermsOfUse = lazy(() => import('../pages/public/terms-of-use/consigner'));
const LoadDetails = lazy(() => import('../pages/web-views/marketplace/active-loads/details'));
const LoadingPoint = lazy(() => import('../pages/web-views/marketplace/active-loads/loadingPoint'));
const UnLoadingPoint = lazy(() => import('../pages/web-views/marketplace/active-loads/unLoadingPoint'));
const Ticket = lazy(() => import('../pages/web-views/marketplace/tickets'));
const Subscribe = lazy(() => import('../pages/web-views/subscribe'));
const Earn = lazy(() => import('../pages/web-views/referral/earn'));
const Join = lazy(() => import('../pages/web-views/referral/join'));
const BuyGPS = lazy(() => import('../pages/web-views/buy-gps'));
const OnboardingOperator = lazy(() => import('../pages/web-views/onboarding-operator'));

const OnboardingOperatorKyc = lazy(() => import('../pages/web-views/operatorKyc'));
const OperatorProfile = lazy(() => import('../pages/web-views/marketplace/OperatorProfile'));
const Statusbar = lazy(() => import('../pages/web-views/rating-story/rating-story'));

export const portalRoutes = [
  {
    path: '/portal/workflow',
    component: Workflow,
    // exact: true,
    isPrivate: true,
    routes: [
      /* {
        path: '/portal/workflow/demand',
        component: Demand,
        exact: true,
        isPrivate: true,
      },

      {
        path: '/portal/workflow/placement',
        component: Placement,
        exact: true,
        isPrivate: true,
      }, */
      {
        path: '/portal/workflow/scheduled',
        component: Scheduled,
        exact: true,
        isPrivate: true,
      },
      /* {
        path: '/portal/workflow/transit',
        component: Transit,
        exact: true,
        isPrivate: true,
      },
      {
        path: '/portal/workflow/history',
        component: History,
        exact: true,
        isPrivate: true,
      }, */
      {
        path: '/portal/workflow/collection/:code',
        component: Collection,
        exact: true,
        isPrivate: true,
      },
      {
        path: '/portal/workflow/docket/:code',
        component: Docket,
        exact: true,
        isPrivate: true,
      },
    ],
  },
  {
    path: '/portal/fastag',
    component: FastagListing,
    exact: true,
    isPrivate: true,
  },
  {
    path: '/portal/fastag/passbook',
    component: FastagPassbook,
    exact: true,
    isPrivate: true,
  },
  {
    path: '/portal/fastag/details',
    component: FastagDetail,
    exact: true,
    isPrivate: true,
  },
  {
    path: '/portal/payment',
    component: Payment,
    exact: true,
    isPrivate: true,
  },
  {
    path: '/portal/transaction/paytm/:orderId',
    component: Response,
    exact: true,
    isPrivate: true,
  },
  {
    path: '/portal/update-consignment',
    component: UpdateConsignment,
    exact: true,
    isPrivate: true,
  },
];

export const publicRoutes = [
  {
    path: '/public/privacy-policy/operator',
    component: PrivacyPolicyOperator,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/public/privacy-policy/thor',
    component: PrivacyPolicyThor,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/public/privacy-policy/consigner',
    component: PrivacyPolicyConsigner,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/public/privacy-policy/hulk',
    component: PrivacyPolicyHulk,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/public/privacy-policy/pump',
    component: PrivacyPolicyPump,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/public/terms-of-use',
    component: TermsOfUse,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/public/terms-of-use/agent',
    component: AgentTerms,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/public/cookie-policy',
    component: CookiePolicy,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/public/terms-of-use/consigner',
    component: ConsignerTermsOfUse,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/public/terms-and-conditions/insurance-consigner',
    component: TermsAndConditionsInsuranceConsigner,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/public/demand-cancellation-policy',
    component: DemandCancellationPolicy,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/public/demand-modification-policy',
    component: DemandModificationPolicy,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/public/payment',
    component: PaymentPage,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/public/plan-payment',
    component: PlanPage,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/public/fleet-load-confirmation',
    component: FleetLoadConfirmation,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/public/operator-tds-declaration',
    component: OperatorTdsDeclaration,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/public/operator-undertaking',
    component: OperatorUndertaking,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/public/operator/detention-policy',
    component: DetentionPolicy,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/public/operator/cancellation-policy',
    component: CancellationPolicy,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/public/operator/token-refund-policy',
    component: TokenRefund,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/public/operator/gtl-delay',
    component: GtlDelay,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/public/operator/over-height',
    component: OverHeight,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/public/operator/over-load',
    component: OverLoad,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/public/operator/service-blacklist-policy',
    component: ServiceBlacklist,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/public/operator/loading-unloading-policy',
    component: LoadingUnloading,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/public/operator/tds-policy',
    component: Tds,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/public/operator/damage-shortage-policy',
    component: DamageShortage,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/public/operator/transit-delay-policy',
    component: TransitDelay,
    exact: true,
    isPrivate: false,
  },
];

export const webViewRoutes = [
  {
    path: '/web-view/marketplace/trips/details/:tripId',
    component: TripDetails,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/web-view/marketplace/trips/details/v2/:tripId',
    component: TripDetailsV2,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/web-view/marketplace/active-loads/details/:demandId',
    component: LoadDetails,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/web-view/marketplace/active-loads/loadingPoint',
    component: LoadingPoint,
    exact: true,
    isPrivate: true,
  },
  {
    path: '/web-view/marketplace/active-loads/unLoadingPoint',
    component: UnLoadingPoint,
    exact: true,
    isPrivate: true,
  },
  {
    path: '/web-view/marketplace/whatsapp-demand',
    component: WhatsAppForm,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/web-view/marketplace/tickets',
    component: Ticket,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/web-view/onboarding-operator/:id',
    component: OnboardingOperator,
    exact: false,
    isPrivate: false,
  },
  {
    path: '/web-view/rating-story',
    component: Statusbar,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/web-view/operatorKyc',
    component: OnboardingOperatorKyc,
    exact: false,
    isPrivate: false,
  },
  {
    path: '/web-view/marketplace',
    component: Marketplace,
    // exact: true,
    isPrivate: false,
    routes: [
      {
        path: '/web-view/marketplace/trips',
        component: Trips,
        exact: true,
        isPrivate: false,
      },
      {
        path: '/web-view/marketplace/operatorProfile',
        component: OperatorProfile,
        exact: true,
        isPrivate: false,
      },
      {
        path: '/web-view/marketplace/my-trips',
        component: Trips,
        exact: true,
        isPrivate: false,
      },

      /* {
        path: '/web-view/marketplace/trips/details/:tripId',
        component: TripDetails,
        exact: true,
        isPrivate: false,
      }, */
      {
        path: '/web-view/marketplace/active-loads',
        component: ActiveLoads,
        exact: true,
        isPrivate: false,
      },
    ],
  },
  /* {
    path: '/web-view/marketplace/trips/list',
    component: Trips,
    exact: true,
    isPrivate: false,
  }, */
  {
    path: '/web-view/subscribe',
    component: Subscribe,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/web-view/referral/earn',
    component: Earn,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/web-view/referral/join',
    component: Join,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/web-view/buy-gps',
    component: BuyGPS,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/web-view/operator-tds-declaration',
    component: TdsDeclaration,
    exact: true,
    isPrivate: false,
  },
];

export const consignerRoutes = [
  {
    path: '/portal/consigner',
    redirect: '/portal/consigner/vehicles',
    exact: true,
    isPrivate: false,
  },
  {
    path: '/portal/consigner/vehicles',
    component: ConsignerVehicle,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/portal/consigner/trips',
    // component: ConsignerVehicle,
    exact: true,
    isPrivate: false,
  },
  {
    path: '/portal/consigner/reports',
    // component: ConsignerVehicle,
    exact: true,
    isPrivate: false,
  },
];
